import styled from 'styled-components';
import { theme } from 'styles';

export const DetailTable = styled.div`
  border: solid 2px ${theme.color.brand_black};
  table {
    width: 100%;
  }
  td {
    border: solid 2px ${theme.color.grey85};
    padding: 0 10px 0 10px;
  }
  tr td:first-child {
    border-left: none;
  }
  tr td:last-child {
    border-right: none;
  }
  tr:first-child td {
    border-top: none;
  }
  tr:last-child td {
    border-bottom: none;
  }
`;
